<template>
  <el-page-header @back="goBack" :content="content"></el-page-header>
</template>
<script>
export default {
  name:'PageHeader',
    props: {
    content: String
  },
  methods: {
    goBack() {
      this.$router.back(-1)
    }
  }
};
</script>